import API from "../configs/axiosInstance";

const getFraudDomains = (domainName, createdDate, isExternal) => {
  return API({
    url: `fraud-service/v1/fraud-domains/all`,
    method: "POST",
    data: {
      domainName,
      createdDate,
      isExternal
    },
  });
};

const startFraudScan = (data) => {
  return API({
    url: `fraud-service/v1/fraud-domains/scan`,
    method: "POST",
    data
  });
}


const getDomainFrauds = (domainId) => {
  return API({
    url: `fraud-service/v1/fraud-domains/${domainId}/by-domain`,
    method: "GET",
  });
}

const getFraudTakeDownStatus = (id) => {
  return API({
    url: `/fraud-service/v1/fraud-process/${id}/fraud`,
    method: 'GET',
  });
};

const startFraudTakeDown = (data) => {
  return API({
    url: `/fraud-service/v1/fraud-process`,
    method: 'POST',
    ...data
  });
};

const getAllFraudTakeDownStatus = (data) => {
  return API({
    url: `/fraud-service/v1/fraud-process/account-fraud-process`,
    method: 'POST',
    ...data
  });
}

const getTakeDownCounts = (id) => {
  return API({
    url: `/fraud-service/v1/fraud-process/status-count`,
    method: 'GET',
  });
};

const fraudService = {
  getFraudDomains,
  startFraudScan,
  getDomainFrauds,
  getFraudTakeDownStatus,
  startFraudTakeDown,
  getAllFraudTakeDownStatus,
  getTakeDownCounts
};

export default fraudService;
